var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stage_8:_Recommitment",
    "data-name": "Stage 8: Recommitment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.024,
    height: 50.024,
    viewBox: "0 0 50.024 50.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    "data-name": "Rectangle 1732",
    width: 37.324,
    height: 33.186,
    fill: "#fff"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_687",
    "data-name": "Ellipse 687",
    cx: 25.012,
    cy: 25.012,
    rx: 25.012,
    ry: 25.012,
    fill: "#ee3d4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32065",
    "data-name": "Group 32065",
    transform: "translate(6.247 10.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32064",
    "data-name": "Group 32064",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13535",
    "data-name": "Path 13535",
    d: "M18.079,12.789a.652.652,0,0,1,1.3,0v.881a3.3,3.3,0,0,1,2.771,3.171.652.652,0,1,1-1.3,0,2.13,2.13,0,0,0-4.24,0,2.055,2.055,0,0,0,.664,1.409,2.018,2.018,0,0,0,1.457.528,3.336,3.336,0,0,1,3.424,3.236,3.3,3.3,0,0,1-2.771,3.171v1.057a.652.652,0,1,1-1.3,0V25.184a3.3,3.3,0,0,1-2.771-3.171.65.65,0,1,1,1.3,0,2.042,2.042,0,0,0,2.114,1.938,1.938,1.938,0,0,0,0-3.875A3.337,3.337,0,0,1,15.3,16.853a3.3,3.3,0,0,1,2.771-3.171Zm1.73,20.061a1.55,1.55,0,0,1-1.9.019C17.234,32.362,1.441,20.281.056,9.911A8.765,8.765,0,0,1,6.426.475C8.161.017,14.1-.724,17.612,8.867a1.555,1.555,0,0,1-2.92,1.071C12.9,5.059,10.177,2.7,7.216,3.482A5.716,5.716,0,0,0,3.13,9.443c1.041,7.791,12.3,17.438,15.692,20.18,3.326-2.8,14.331-12.615,15.37-20.379A5.728,5.728,0,0,0,30.111,3.23c-2.443-.645-4.731.856-6.463,4.15l1.247.587a.352.352,0,0,1,.053.616l-4.712,3.285a.354.354,0,0,1-.493-.076.358.358,0,0,1-.067-.187l-.484-5.717a.352.352,0,0,1,.507-.352l1.124.528C24.365-.819,29.333-.18,30.9.231a8.78,8.78,0,0,1,6.366,9.48c-1.377,10.308-16.8,22.62-17.457,23.138",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage8);
export default __webpack_public_path__ + "static/media/stage8.73ad3cc3c41ce15e84c33e4687466ebd.svg";
export { ForwardRef as ReactComponent };